// All strategy fund rules

import { IProduct } from '../../../../models/product'
import { ClassificationRulesService } from '../../../classification-rules/classification-rules.service'
import { FundRuleName } from '../fund-rule-name'
import { IFundRule } from '../ifund-rule'

export class DividendStrategyRule implements IFundRule {
  ruleName = FundRuleName.DIVIDEND_STRATEGY
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesService.isDividendStrategy(fund)
  }
}

export class ESGStrategyRule implements IFundRule {
  ruleName = FundRuleName.ESG_STRATEGY
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesService.isESGStrategies(fund)
  }
}

export class FactorDrivenStrategyRule implements IFundRule {
  ruleName = FundRuleName.FACTOR_DRIVEN_STRATEGY
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesService.isFactorDrivenStrategies(fund)
  }
}

export class SectorAndSpecialityRule implements IFundRule {
  ruleName = FundRuleName.SECTOR_SPECIALITY_STRATEGY
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesService.isAlternativeSplLevel1(fund)
  }
}
